import React from 'react';
import { Avatar as BiddingAssistantAvatar } from 'components/atoms/chatbot_message/styles';
import { Avatar as ConsultorAvatar } from 'components/molecules/chatbot_assistant_chat/styles';

export type ChatbotTypingRowVariant = 'bidding_chat' | 'consultor_chat';

interface ChatbotTypingRowProps {
  variant: ChatbotTypingRowVariant;
}

const ChatbotTypingRow: React.FC<ChatbotTypingRowProps> = ({ variant }) => {
  const author =
    variant === 'bidding_chat' ? (
      <div className="message-author px-3 pt-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column align-items-center">
              <BiddingAssistantAvatar className="chatbot-avatar btn-ia">IA</BiddingAssistantAvatar>
            </div>
            <span className="font-weight-bold author-name">Consultor Jurídico</span>
          </div>
        </div>
      </div>
    ) : (
      <div className="message-author px-3 pt-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <ConsultorAvatar className="chatbot-avatar">IA</ConsultorAvatar>
            <span className="font-weight-bold author-name">Consultor Jurídico</span>
          </div>
        </div>
      </div>
    );

  return (
    <div className="message assistant">
      <div className="message-box">
        {author}
        <div className="message-date text-right p-0 pt-3 px-3 p-md-3" aria-hidden="true" />
        <div className="message-text p-3">
          <div
            className="message-loading chatbot-typing-indicator"
            role="status"
            aria-live="polite"
          >
            <span className="chatbot-typing-label">Digitando</span>
            <span className="chatbot-typing-dots" aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotTypingRow;
